"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autosave = void 0;
var http_1 = require("./http");
var autosaved = [];
var loopStarted = false;
var token;
var loop = function () {
    autosaved.forEach(function (item) {
        if (item._backup !== JSON.stringify(item.model)) {
            if (item.fn) {
                item.fn();
            }
            else {
                http_1.http[item.method](item.path, item.model);
            }
            item._backup = JSON.stringify(item.model);
        }
    });
    loopStarted = true;
    token = setTimeout(loop, 500);
};
var Autosave = /** @class */ (function () {
    function Autosave() {
    }
    Autosave.watch = function (path, model, method) {
        if (method === void 0) { method = 'put'; }
        if (autosaved.findIndex(function (e) { return e.model === model && e.path === path; }) !== -1) {
            return;
        }
        var autosave;
        if (typeof path === 'string') {
            autosave = {
                model: model,
                path: path,
                method: method
            };
        }
        else {
            autosave = {
                model: model,
                fn: path,
                method: method
            };
        }
        autosaved.push(autosave);
        if (!loopStarted) {
            loop();
        }
    };
    Autosave.unwatch = function (model) {
        var index = autosaved.findIndex(function (e) { return e.model === model; });
        autosaved.splice(index, 1);
        if (autosaved.length === 0) {
            this.unwatchAll();
        }
    };
    Autosave.unwatchAll = function () {
        autosaved = [];
        clearTimeout(token);
        loopStarted = false;
    };
    return Autosave;
}());
exports.Autosave = Autosave;



//////////////////
// WEBPACK FOOTER
// /home/node/app/~/entcore-toolkit/dist/autosaver.js
// module id = 24
// module chunks = 0 1